module.exports = __webpack_public_path__ + "img/sp-icon-delete-new.de319b25.svg";